'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _f3tch = require('f3tch');

var _constants = require('./constants.api');

var _apiKeyConst = require('../card/consts/apiKey.const.card');

var _apiKeyConst2 = _interopRequireDefault(_apiKeyConst);

var _token = require('../auth/token.auth');

var _error = require('./error.api');

var _error2 = require('../auth/error.auth');

var _error3 = _interopRequireDefault(_error2);

var _event = require('../auth/event.auth');

var _parseRawServerError = require('./parseRawServerError.api');

var _parseRawServerError2 = _interopRequireDefault(_parseRawServerError);

var _parseServerError = require('./parseServerError.api');

var _parseServerError2 = _interopRequireDefault(_parseServerError);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Helpers
// Libs
// Token
// Constants


var headers = function headers() {
  var file = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var token = _token.authToken.get();

  var h = file ? {} : {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };
  if (token) h.Authorization = 'JWT ' + token;
  return h;
}; // Events
// Errors


var shortUrlHeaders = function shortUrlHeaders() {
  var file = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var token = _token.authToken.get();

  var h = file ? {} : {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };
  if (token) h.Authorization = token;
  return h;
};

var statementHeaders = function statementHeaders() {
  var token = _token.authToken.get();

  var h = {
    'Content-Type': 'application/json'
  };
  if (token) h.Authorization = 'JWT ' + token;
  return h;
};

var pdfGeneratorHeaders = function pdfGeneratorHeaders() {
  var token = _token.authToken.get();

  var h = {
    'Content-Type': 'application/json'
  };
  if (token) h.Authorization = token;
  return h;
};

var htmlHeaders = function htmlHeaders() {
  var token = _token.authToken.get();

  var h = {
    'Content-Type': 'text/html'
  };
  if (token) h.Authorization = 'JWT ' + token;
  return h;
};

var isUnauthorized = function isUnauthorized(_ref) {
  var status = _ref.status;
  var dispatchEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (status === 401) {
    if (dispatchEvent) (0, _event.pub)();
    throw (0, _error3.default)({
      message: 'User is unauthorised'
    });
  }
};

var isApiError = function () {
  var _ref2 = (0, _asyncToGenerator3.default)(
  /*#__PURE__*/
  _regenerator2.default.mark(function _callee(response) {
    var rawMessage, data;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(response.status >= 500)) {
              _context.next = 13;
              break;
            }

            rawMessage = null;
            _context.prev = 2;
            _context.next = 5;
            return response.text();

          case 5:
            rawMessage = _context.sent;
            _context.next = 12;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](2);
            console.error(response);
            throw (0, _error.unknownServerError)({
              message: _context.t0.message
            });

          case 12:
            throw (0, _error.apiError)({
              message: 'Server Error: ' + (0, _parseRawServerError2.default)(rawMessage)
            });

          case 13:
            if (!(response.status < 200 || response.status >= 300)) {
              _context.next = 26;
              break;
            }

            data = null;
            _context.prev = 15;
            _context.next = 18;
            return response.json();

          case 18:
            data = _context.sent;
            _context.next = 25;
            break;

          case 21:
            _context.prev = 21;
            _context.t1 = _context['catch'](15);
            console.error(response);
            throw (0, _error.unknownServerError)({
              message: _context.t1.message
            });

          case 25:
            throw (0, _error.apiError)((0, _parseServerError2.default)(data));

          case 26:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[2, 8], [15, 21]]);
  }));

  return function isApiError(_x4) {
    return _ref2.apply(this, arguments);
  };
}();

(0, _f3tch.profile)('json').url(_constants.url).headers(headers).responder(function () {
  var _ref3 = (0, _asyncToGenerator3.default)(
  /*#__PURE__*/
  _regenerator2.default.mark(function _callee2(response) {
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            isUnauthorized(response);
            _context2.next = 3;
            return isApiError(response);

          case 3:
            _context2.prev = 3;
            _context2.next = 6;
            return response.json();

          case 6:
            return _context2.abrupt('return', _context2.sent);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2['catch'](3);
            throw (0, _error.unknownServerError)({
              message: _context2.t0.message
            });

          case 12:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined, [[3, 9]]);
  }));

  return function (_x5) {
    return _ref3.apply(this, arguments);
  };
}());
(0, _f3tch.profile)('unauth-json').url(_constants.url).headers({
  Accept: 'application/json',
  'Content-Type': 'application/json'
}).responder(function () {
  var _ref4 = (0, _asyncToGenerator3.default)(
  /*#__PURE__*/
  _regenerator2.default.mark(function _callee3(response) {
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            isUnauthorized(response, false);
            _context3.next = 3;
            return isApiError(response);

          case 3:
            _context3.prev = 3;
            _context3.next = 6;
            return response.json();

          case 6:
            return _context3.abrupt('return', _context3.sent);

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3['catch'](3);
            throw (0, _error.unknownServerError)({
              message: _context3.t0.message
            });

          case 12:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined, [[3, 9]]);
  }));

  return function (_x6) {
    return _ref4.apply(this, arguments);
  };
}());
(0, _f3tch.profile)('unauth-json-no-url').headers({
  Accept: 'application/json',
  'Content-Type': 'application/json'
}).responder(function () {
  var _ref5 = (0, _asyncToGenerator3.default)(
  /*#__PURE__*/
  _regenerator2.default.mark(function _callee4(response) {
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            isUnauthorized(response);
            _context4.next = 3;
            return isApiError(response);

          case 3:
            _context4.prev = 3;
            _context4.next = 6;
            return response.json();

          case 6:
            return _context4.abrupt('return', _context4.sent);

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4['catch'](3);
            throw (0, _error.unknownServerError)({
              message: _context4.t0.message
            });

          case 12:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined, [[3, 9]]);
  }));

  return function (_x7) {
    return _ref5.apply(this, arguments);
  };
}());
(0, _f3tch.profile)('short-url').headers(shortUrlHeaders).responder(function () {
  var _ref6 = (0, _asyncToGenerator3.default)(
  /*#__PURE__*/
  _regenerator2.default.mark(function _callee5(response) {
    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return isApiError(response);

          case 2:
            _context5.prev = 2;
            _context5.next = 5;
            return response.json();

          case 5:
            return _context5.abrupt('return', _context5.sent);

          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5['catch'](2);
            throw (0, _error.unknownServerError)({
              message: _context5.t0.message
            });

          case 11:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, undefined, [[2, 8]]);
  }));

  return function (_x8) {
    return _ref6.apply(this, arguments);
  };
}());
(0, _f3tch.profile)('stripe').url(_constants.url).headers(function () {
  return {
    'Content-Type': 'application/json',
    'x-cards-apikey': (0, _apiKeyConst2.default)()
  };
}).responder(function () {
  var _ref7 = (0, _asyncToGenerator3.default)(
  /*#__PURE__*/
  _regenerator2.default.mark(function _callee6(response) {
    return _regenerator2.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return isApiError(response);

          case 2:
            _context6.prev = 2;
            _context6.next = 5;
            return response.json();

          case 5:
            return _context6.abrupt('return', _context6.sent);

          case 8:
            _context6.prev = 8;
            _context6.t0 = _context6['catch'](2);
            throw (0, _error.unknownServerError)({
              message: _context6.t0.message
            });

          case 11:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, undefined, [[2, 8]]);
  }));

  return function (_x9) {
    return _ref7.apply(this, arguments);
  };
}());
(0, _f3tch.profile)('file').url(_constants.url).headers(function () {
  return headers(true);
}).responder(function () {
  var _ref8 = (0, _asyncToGenerator3.default)(
  /*#__PURE__*/
  _regenerator2.default.mark(function _callee7(response) {
    return _regenerator2.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            isUnauthorized(response);
            _context7.next = 3;
            return isApiError(response);

          case 3:
            _context7.prev = 3;
            _context7.next = 6;
            return response.json();

          case 6:
            return _context7.abrupt('return', _context7.sent);

          case 9:
            _context7.prev = 9;
            _context7.t0 = _context7['catch'](3);
            throw (0, _error.unknownServerError)({
              message: _context7.t0.message
            });

          case 12:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, undefined, [[3, 9]]);
  }));

  return function (_x10) {
    return _ref8.apply(this, arguments);
  };
}());
(0, _f3tch.profile)('blob').url(_constants.url).headers(statementHeaders).responder(function () {
  var _ref9 = (0, _asyncToGenerator3.default)(
  /*#__PURE__*/
  _regenerator2.default.mark(function _callee8(response) {
    return _regenerator2.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            isUnauthorized(response);
            _context8.next = 3;
            return isApiError(response);

          case 3:
            _context8.prev = 3;
            _context8.next = 6;
            return response.blob();

          case 6:
            return _context8.abrupt('return', _context8.sent);

          case 9:
            _context8.prev = 9;
            _context8.t0 = _context8['catch'](3);
            throw (0, _error.unknownServerError)({
              message: _context8.t0.message
            });

          case 12:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, undefined, [[3, 9]]);
  }));

  return function (_x11) {
    return _ref9.apply(this, arguments);
  };
}());
(0, _f3tch.profile)('pdf-converter').headers(pdfGeneratorHeaders).responder(function () {
  var _ref10 = (0, _asyncToGenerator3.default)(
  /*#__PURE__*/
  _regenerator2.default.mark(function _callee9(response) {
    return _regenerator2.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            isUnauthorized(response);
            _context9.next = 3;
            return isApiError(response);

          case 3:
            _context9.prev = 3;
            _context9.next = 6;
            return response.blob();

          case 6:
            return _context9.abrupt('return', _context9.sent);

          case 9:
            _context9.prev = 9;
            _context9.t0 = _context9['catch'](3);
            throw (0, _error.unknownServerError)({
              message: _context9.t0.message
            });

          case 12:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, undefined, [[3, 9]]);
  }));

  return function (_x12) {
    return _ref10.apply(this, arguments);
  };
}());
(0, _f3tch.profile)('text').url(_constants.url).headers(headers).responder(function () {
  var _ref11 = (0, _asyncToGenerator3.default)(
  /*#__PURE__*/
  _regenerator2.default.mark(function _callee10(response) {
    return _regenerator2.default.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            isUnauthorized(response);
            _context10.next = 3;
            return isApiError(response);

          case 3:
            _context10.prev = 3;
            _context10.next = 6;
            return response.text();

          case 6:
            return _context10.abrupt('return', _context10.sent);

          case 9:
            _context10.prev = 9;
            _context10.t0 = _context10['catch'](3);
            throw (0, _error.unknownServerError)({
              message: _context10.t0.message
            });

          case 12:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, undefined, [[3, 9]]);
  }));

  return function (_x13) {
    return _ref11.apply(this, arguments);
  };
}());
(0, _f3tch.profile)('html').url(_constants.url).headers(htmlHeaders).responder(function () {
  var _ref12 = (0, _asyncToGenerator3.default)(
  /*#__PURE__*/
  _regenerator2.default.mark(function _callee11(response) {
    return _regenerator2.default.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            isUnauthorized(response);
            _context11.next = 3;
            return isApiError(response);

          case 3:
            _context11.prev = 3;
            _context11.next = 6;
            return response.text();

          case 6:
            return _context11.abrupt('return', _context11.sent);

          case 9:
            _context11.prev = 9;
            _context11.t0 = _context11['catch'](3);
            throw (0, _error.unknownServerError)({
              message: _context11.t0.message
            });

          case 12:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, undefined, [[3, 9]]);
  }));

  return function (_x14) {
    return _ref12.apply(this, arguments);
  };
}());
(0, _f3tch.profile)('no-data').url(_constants.url).headers(headers).responder(function () {
  var _ref13 = (0, _asyncToGenerator3.default)(
  /*#__PURE__*/
  _regenerator2.default.mark(function _callee12(response) {
    return _regenerator2.default.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            isUnauthorized(response);
            _context12.next = 3;
            return isApiError(response);

          case 3:
            return _context12.abrupt('return', true);

          case 4:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, undefined);
  }));

  return function (_x15) {
    return _ref13.apply(this, arguments);
  };
}());
(0, _f3tch.profile)('statement').url(_constants.url).headers(statementHeaders).responder(function () {
  var _ref14 = (0, _asyncToGenerator3.default)(
  /*#__PURE__*/
  _regenerator2.default.mark(function _callee13(response) {
    return _regenerator2.default.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            isUnauthorized(response);
            _context13.next = 3;
            return isApiError(response);

          case 3:
            _context13.prev = 3;
            _context13.next = 6;
            return response.blob();

          case 6:
            return _context13.abrupt('return', _context13.sent);

          case 9:
            _context13.prev = 9;
            _context13.t0 = _context13['catch'](3);
            throw (0, _error.unknownServerError)({
              message: _context13.t0.message
            });

          case 12:
          case 'end':
            return _context13.stop();
        }
      }
    }, _callee13, undefined, [[3, 9]]);
  }));

  return function (_x16) {
    return _ref14.apply(this, arguments);
  };
}());